module.exports={author:"Margaret Yapp",date:"09/11/2026",publishDate:"09/11/2026",highlighted:!0,tags:"",badge:"",title:"SOLID STATE DRIVE"};